export default {
	tenantId: "walaa_production",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "walaa--production",
	},
}
